import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Card, CardText, CardActions} from 'material-ui/Card';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';
import RaisedButton from 'material-ui/RaisedButton';
import ActionCheck from 'material-ui/svg-icons/action/check-circle';
import AlertError from 'material-ui/svg-icons/alert/error-outline';
import compose from 'recompose/compose';
import ViewTitle from 'admin-on-rest/lib/mui/layout/ViewTitle';
import {ListButton} from 'admin-on-rest/lib/mui/button';
import {
    crudDelete as crudDeleteAction,
} from 'admin-on-rest/lib/actions/dataActions';
import translate from 'admin-on-rest/lib/i18n/translate';
import FuseTheme from "../global/theme";

const styles = {
    actions: {zIndex: 2, display: 'inline-block', float: 'right'},
    toolbar: {clear: 'both'},
    button: {margin: '10px 24px', position: 'relative'},
    fieldDescription: {
        flex: '1 1 40%',
        display: 'block',
        width: 'auto',
        fontSize: '12px',
        color: FuseTheme.palette.lightTextColor,
        margin: '1em 0 0 0',
    },
    break: {display: 'block', width: '100%', height: 0, border: 'none', margin: 0},
};

class DeleteLocationInventory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            location_id: '',
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.goBack = this.goBack.bind(this);
    }

    componentDidMount() {
        console.log('this.props ', this.props);
        this.getData(this.props);
    }

    extractDataFromPath() {
        const {location} = this.props;
        const pathArray = location.pathname.split('/');
        return {
            'resource': pathArray[1],
            'location_id': pathArray[2],
        };
    }

    getData(props) {
        if (props && props.location) {
            const path = this.extractDataFromPath();
            this.setState({
                location_id: path.location_id,
            });
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.crudDelete(
            this.props.resource,
            this.state.location_id,
            {},
            this.props.listPath
        );
    }

    goBack() {
        this.props.history.goBack();
    }

    render() {
        const {
            isLoading,
            listPath,
            title,
            translate,
        } = this.props;

        return (
            <div>
                <Card style={{opacity: isLoading ? 0.8 : 1}}>
                    <CardActions style={styles.actions}>
                        <ListButton basePath={listPath}/>
                    </CardActions>
                    <ViewTitle title={title}/>
                    <form onSubmit={this.handleSubmit}>
                        <CardText>
                            {translate('aor.message.are_you_sure')}
                            <hr style={styles.break}/>
                            <span style={styles.fieldDescription}>This will clear all Inventory from Location
                                ID #{this.state.location_id}.</span>
                            <hr style={styles.break}/>
                        </CardText>
                        <Toolbar style={styles.toolbar}>
                            <ToolbarGroup>
                                <RaisedButton
                                    type="submit"
                                    label="Zero Out Inventory"
                                    icon={<ActionCheck/>}
                                    primary
                                    style={styles.button}
                                />
                                <RaisedButton
                                    label={translate('aor.action.cancel')}
                                    icon={<AlertError/>}
                                    onClick={this.goBack}
                                    style={styles.button}
                                />
                            </ToolbarGroup>
                        </Toolbar>
                    </form>
                </Card>
            </div>
        );
    }
}

DeleteLocationInventory.propTypes = {
    listPath: PropTypes.string.isRequired,
    title: PropTypes.any,
    resource: PropTypes.string.isRequired,
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    data: PropTypes.object,
    isLoading: PropTypes.bool,
    crudDelete: PropTypes.func,
    translate: PropTypes.func,
};

function mapStateToProps(state, props) {
    let resource = state.admin.resources[props.resource];
    if (resource) {
        return {
            data: (resource.data) ? resource.data : null,
        };
    }
    return {
        data: {}
    };
}

const enhance = compose(
    connect(mapStateToProps, {
        crudDelete: crudDeleteAction,
    }),
    translate
);

export default enhance(DeleteLocationInventory);



// WEBPACK FOOTER //
// ./src/Fuse/admin/DeleteLocationInventory.js